module.exports = __webpack_public_path__ + "static/media/maf-25.0fe63432.png";